module.exports = __webpack_public_path__ + "img/consult_info6.1c47dfd6.png";